const AnalyticsServices = {
  JUNE_SO: "JuneSo",
  GTAG: "Google Analytics",
  HUBSPOT: "Hubspot",
  MIXPANEL: "Mixpanel",
};
export const { JUNE_SO, GTAG, RECOMMENDED_GTAG, HUBSPOT, MIXPANEL } = AnalyticsServices;

export default AnalyticsServices;
